<div class="container-fluid" style=" padding-right: 0px; padding-left: 0px">
  <app-nav-menu></app-nav-menu>
</div>
<div class="container" id="desktop">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.6em; font-weight:bold">
      Contact Information
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 mt-1" style="font-size:2.0em">
      Notice Administrator
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/ab-data-logo.png" alt="">
          </td>
          <td style="vertical-align: middle; width: 75%">
            <b>Period Tracker Data Privacy Litigation</b><br />
            c/o A.B. Data<br />
            P.O. Box 173126<br />
            Milwaukee, WI 53217<br />
            <a href="mailto:info@PeriodTrackerDataPrivacyLitigation.com" style="color:#006cDb">info@PeriodTrackerDataPrivacyLitigation.com</a><br />
            Toll Free: (866) 778-9626
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row mt-4">
    <div class="col-md-12" style="font-size:2.0em">
      Class Counsel
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/LogoLKS.png" alt="">
          </td>
          <td style="vertical-align:middle; width:75%">

            <b>Carol C. Villegas</b><br />
            LABATON KELLER SUCHAROW LLP<br />
            140 Broadway<br />
            New York, NY 10005<br />
          </td>
        </tr>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/LogoLowey.png" alt="">
          </td>
          <td style="vertical-align:middle; width:75%">
            <b>Christian Levis</b><br />
            LOWEY DANNENBERG, P.C.<br />
            44 South Broadway<br />
            Suite 1100<br />
            White Plains, NY 10601<br />
          </td>
        </tr>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/LogoSpector.png" alt="">
          </td>
          <td style="vertical-align:middle; width:75%">
            <b>Diana J. Zinser</b><br />
            SPECTOR CALDES & CORRIGAN, P.C.<br />
            2001 Market Street<br />
            Suite 3420<br />
            Philadelphia, PA 19103<br />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="container" id="mobile">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.0em; font-weight:bold">
      Contact Information
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 mt-1" style="font-size:1.6em">
      Notice Administrator
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/ab-data-logo.png" alt="">
          </td>
          <td style="vertical-align: middle; width: 75%; font-size: .8em">
            <b>Period Tracker Data Privacy Litigation</b><br />
            c/o A.B. Data<br />
            P.O. Box 173126<br />
            Milwaukee, WI 53217<br />
            <a href="mailto:info@PeriodTrackerDataPrivacyLitigation.com" style="color:#006cDb">info@PeriodTrackerDataPrivacyLitigation.com</a><br />
            Toll Free: (866) 778-9626
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row mt-4">
    <div class="col-md-12" style="font-size:1.6em">
      Class Counsel
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/LogoLKS.png" alt="">
          </td>
          <td style="vertical-align: middle; width: 75%; font-size: .8em">

            <b>Carol C. Villegas</b><br />
            LABATON KELLER SUCHAROW LLP<br />
            140 Broadway<br />
            New York, NY 10005<br />
          </td>
        </tr>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/LogoLowey.png" alt="">
          </td>
          <td style="vertical-align: middle; width: 75%; font-size: .8em">
            <b>Christian Levis</b><br />
            LOWEY DANNENBERG, P.C.<br />
            44 South Broadway<br />
            Suite 1100<br />
            White Plains, NY 10601<br />
          </td>
        </tr>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/LogoSpector.png" alt="">
          </td>
          <td style="vertical-align: middle; width: 75%; font-size: .8em">
            <b>Diana J. Zinser</b><br />
            SPECTOR CALDES & CORRIGAN, P.C.<br />
            2001 Market Street<br />
            Suite 3420<br />
            Philadelphia, PA 19103<br />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>




